export const metaTypeList = [
  { id: 0, type: "name" },
  { id: 1, type: "property" },
];

export const metaContentList = [
  { id: 0, type: "keywords" },
  { id: 1, type: "description" },
];
